import { DESCONTO_EM_FOLHA_POR_OPERADOR } from "@/constants/justifications.id";

export interface PayrollDiscountCandidate {
  readonly is_loss?: boolean | null;
  readonly justification_id?: number | null;
  readonly is_payroll_discount?: boolean | null;
}

export const isPayrollDiscount = (
  candidate: PayrollDiscountCandidate
): boolean => {
  if (typeof candidate.is_payroll_discount === "boolean") {
    return candidate.is_payroll_discount;
  }

  return candidate.justification_id === DESCONTO_EM_FOLHA_POR_OPERADOR;
};

export const isLossWithdrawn = (
  candidate: PayrollDiscountCandidate
): boolean => candidate.is_loss === false && !isPayrollDiscount(candidate);
